import Login from 'components/pages/login/Login'
import Activation from 'components/pages/login/Activation'
import GetPassword from 'components/pages/login/GetPassword'
import ResetPassword from 'components/pages/login/ResetPassword'
import ResetVehiclePassword from 'components/pages/login/ResetVehiclePassword'
import App from 'src/App'
import Update from 'components/layouts/Update'
import Home from 'components/layouts/Home'
import DetailHome from 'components/pages/carfile/detail/DetailHome.vue'
import DetailBasic from 'components/pages/carfile/detail/DetailBasic.vue'
import DetailDevice from 'components/pages/carfile/detail/DetailDevice.vue'
import DetailOwner from 'components/pages/carfile/detail/DetailOwner.vue'
import DetailAlarm from 'components/pages/carfile/detail/DetailAlarm.vue'
import DetailObd from 'components/pages/carfile/detail/DetailObd.vue'
import ContentTab from 'components/layouts/ContentTab'
import DetailInfo from 'components/pages/devicedetail/DetailInfo'
import HistoryPosition from 'components/pages/devicedetail/HistoryPosition'
import HistoryInstruction from 'components/pages/devicedetail/HistoryInstruction'
export default [
		{
			path:'/indexUpdate',
			components:{
				app:Update
			}
		},
		{
			path: '/resetvehiclepassword/:token',
			components:{
				app:ResetVehiclePassword
			},
		},
		{
			path: '/resetpassword/:token',
			components:{
				app:ResetPassword
			},
		},
		{
			path: '/getpassword',
			components:{
				app:GetPassword
			},
		},
		{
			path: '/activation/:token',
			components:{
				app:Activation
			},
		},
		{
			path: '/',
			components:{
				app:Login
			},
			beforeEnter: (to, from, next) => {
				if (window.localStorage.getItem('user')) {
		            next({
		                path: '/indexhome',
		                query: {redirect: to.fullPath}
		            });
		        }else{
		        	next();
		        }
			}
		},
		{
			path: '/login',
			components:{
				app:Login
			},
			beforeEnter: (to, from, next) => {
				if (window.localStorage.getItem('user')) {
		            next({
		                path: '/indexhome',
		                query: {redirect: to.fullPath}
		            });
		        }else{
		        	next();
		        }
			}
		},
		{
			path:'/indexhome',
			components:{
				app:Home
			},
			meta: { requiresAuth: true },
			children:[
	            	{
						path:'/',
						components:{
							cntBody:ContentTab
						}
					},
					{
						path:':id',
						components:{
							cntBody:ContentTab
						},
						children:[
							{
								path:'/',
								components:{
									detail:DetailHome,
									device:DetailInfo
								}
							},
							{
								path:'detailHome',
								components:{
									detail:DetailHome
								}
							},
							{
								path:'detailBasic',
								components:{
									detail:DetailBasic
								}
								
							},
							{
								path:'detailDevice',
								components:{
									detail:DetailDevice
								}
								
							},
							{
								path:'detailOwner',
								components:{
									detail:DetailOwner
								}
								
							},
							{
								path:'detailAlarm',
								components:{
									detail:DetailAlarm
								}
								
							},
							{
								path:'detailObd',
								components:{
									detail:DetailObd
								}
								
							},
							{
								path:'detailInfo',
								components:{
									device:DetailInfo
								}
								
							},
							{
								path:'historyInstruction',
								components:{
									device:HistoryInstruction
								}
								
							},
							{
								path:'historyPosition',
								components:{
									device:HistoryPosition
								}
								
							}
						]
					}
	            ]
		} 
	
]


// WEBPACK FOOTER //
// ./src/routes/router.js